import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import Markdown from "react-markdown"

import { SitesWrapper } from "gatsby-theme-gba"
import { createElement } from "../../utils/create-elements"
const apiKey = process.env.GATSBY_GOOGLE_MAP_API // process.env.GATSBY_GOOGLE_MAP_API_GEOCODE

const SitesWrapperEditable = ({ blok }) => {
  const backgroundImage = "/block-3rd-party-maps.jpg"

  let link = ""
  if (blok.infoUrl) {
    link = blok.infoUrl.id
      ? transformLinkUri(blok.infoUrl.id, "", blok.currentLanguage)
      : blok.infoUrl.cached_url
  }
  const sites = useStaticQuery(graphql`
    query sitesWrapperQuery {
      allStoryblokEntry(
        filter: {
          field_longitude_string: { regex: "/.+/i" }
          field_latitude_string: { regex: "/.+/i" }
        }
      ) {
        edges {
          node {
            id
            internalId
            default_full_slug
            name
            created_at
            uuid
            slug
            full_slug
            content
            sort_by_date
            lang
            translated_slugs {
              lang
              path
            }
          }
        }
      }
    }
  `)

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <SitesWrapper
        sites={sites.allStoryblokEntry.edges}
        currentLanguage={blok.currentLanguage}
        centerLng={Number(blok.centerLng)}
        ceneterLat={Number(blok.centerLat)}
        zoomLevel={Number(blok.zoom)}
        apiKey={apiKey}
        mapSearchRadius={Number(blok.mapSearchRadius)}
        thirdPartyInfo={{
          cookieKey: blok.cookieKey,
          backgroundUrl: backgroundImage,
          buttonText: blok.buttonText,
          buttonPermanentText: blok.buttonPermanentText,
          infoText: blok.infoTextMap,
          infoUrl: link,
          infoUrlText: blok.infoUrlText,
          block3rdParty: blok.block3rdParty,
        }}
        infoText={
          <Markdown
            transformLinkUri={(uri) => {
              return transformLinkUri(uri, "", blok.currentLanguage)
            }}
          >
            {blok.infoText}
          </Markdown>
        }
      >
        {createElement(blok)}
      </SitesWrapper>
    </div>
  )
}

export default SitesWrapperEditable
